import React from "react";
import { Button, Modal } from "react-bootstrap";

const MyModal = ({ show, setShow, head, body }) => {
  return (
    <div>
      <Modal size="lg" show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <div className="w-100 text-center">
            <h2 className="m-0">{head}</h2>
          </div>
        </Modal.Header>
        <Modal.Body>{body}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShow(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default MyModal;
